import { useTranslate } from '@tolgee/react';
import DecorateTitle from 'components/DecorateTitle';
import chatttSDK from 'services/chattt';
import SettingItemContainer from './SettingItemContainer';
import { Slider, Space } from 'antd';

export const ZoomView = () => {
  const { t } = useTranslate();

  return (
    <>
      <DecorateTitle>{t('ViewSystem.system.page.size.title')}</DecorateTitle>
      <SettingItemContainer>
        <Space>
          <span>{t('ViewSystem.system.page.size.small')}</span>
          <div style={{ width: 200 }}>
            <Slider
              dots
              min={0.5}
              max={1.5}
              step={0.1}
              defaultValue={chatttSDK?.app?.getZoomFactor?.() || 1}
              tooltipVisible={false}
              onChange={(val) => {
                chatttSDK?.app?.setZoomFactor?.(val);
              }}
            />
          </div>
          <span>{t('ViewSystem.system.page.size.large')}</span>
        </Space>
      </SettingItemContainer>
    </>
  );
};
